import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { Worker, CustomAction, WorkerStatus } from '@nimmsta/ng-commons-lib';

_('worker.pair');
_('worker.unpair');

export class PairUnpairAction extends CustomAction<Worker> {
  constructor() {
    super('worker.pair', true);
    this.btnClass = 'btn-outline-primary';
  }

  override getClass(worker: Worker): string {
    switch (worker.status) {
      case WorkerStatus.NOT_PAIRED:
        return 'btn-outline-secondary connect';
      case WorkerStatus.PAIRED:
        return 'btn-outline-primary disconnect';
      case WorkerStatus.ACTIVE:
        return 'btn-outline-danger disconnect';
      default:
        throw new Error('Unknown worker status');
    }
  }

  override getText(worker: Worker): string {
    switch (worker.status) {
      case WorkerStatus.NOT_PAIRED:
        return 'worker.pair';
      case WorkerStatus.PAIRED:
        return 'worker.unpair';
      case WorkerStatus.ACTIVE:
        return 'worker.unpair-active';
      default:
        throw new Error('Unknown worker status');
    }
  }
}
